/**
 * Avatar URL shared by Ask Anonymously and Primum Support.
 */
export const PRIMUM_AVATAR_URL =
  'https://s3.us-east-1.amazonaws.com/primum.co-images/d1576af6-77dd-4225-874b-7707d22b23c7-128px.png';

export const ANONYMOUS_EXPERT = {
  empty: false,
  name: 'Ask Anonymously',
  avatarSrc: PRIMUM_AVATAR_URL,
  focusArea: 'all cancer types',
  focusAreaExpanded: 'Available across all cancer types',
  preferredExpertMessage:
    'Primum believes in the importance of asking the right questions – no matter how straightforward or simple they might seem.  Primum is built on the belief that collaboration enhances outcomes and strengthens confidence, and one way we can support you in providing the best possible care is by making it easy to submit your inquiries anonymously. While we strive to foster an environment where no one feels embarrassed to submit an inquiry, we understand there can be hesitation.',
  simpleSubmissionMessage:
    "After submitting your inquiry, we'll connect it to an expert in your desired field without sharing your identity. Have a preferred expert? Indicate that in your message. Let us help you be the best oncologist you can be.",
  specificProviderMessage:
    'If you would like your inquiry to go to a specific provider, please indicate that in your message field.',
  directoryCardDescription:
    'Submit your inquiries anonymously across all cancer fields. Indicate a specific provider, or have us match you.',
  directoryCardFocusAreas: 'Supported across all cancer types',
} as const;

/**
 * Primum Support user for the reference support bubble in chat.
 */
export const PRIMUM_SUPPORT_USER = {
  id: 'primum-support',
  name: 'Primum Support',
  avatarSrc: PRIMUM_AVATAR_URL,
} as const;
